import axios from "axios";
import { requestError } from "../utils/RequestError";

export const getMiLibraryList = async (params) => {
  try {
    const res = await axios.get(`/admin/mi-libraries/assets`, { params });
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const addMiLibrary = async (payload) => {
  try {
    const res = await axios.post(`/admin/mi-libraries/assets`, payload);
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const updateMiLibrary = async (id, payload) => {
  try {
    const res = await axios.put(`/admin/mi-libraries/assets/${id}`, payload);
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const searchMiLibraryCategories = async (params) => {
  try {
    const res = await axios.get(`/admin/mi-libraries/categories`, { params });
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const createMiLibraryCategory = async (payload) => {
  try {
    const res = await axios.post(`/admin/mi-libraries/categories`, payload);
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const deleteMiLibrary = async (id) => {
  try {
    const res = await axios.delete(`/admin/mi-libraries/assets/${id}`);
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const getMiLibraryCategories = async (params) => {
  try {
    const res = await axios.get(`/admin/mi-libraries/categories`, { params });
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const addMiLibraryCategory = async (payload) => {
  try {
    const res = await axios.post(`/admin/mi-libraries/categories`, payload);
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const updateMiLibraryCategory = async (id, payload) => {
  try {
    const res = await axios.put(`/admin/mi-libraries/categories/${id}`, payload);
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const deleteMiLibraryCategory = async (id) => {
  try {
    const res = await axios.delete(`/admin/mi-libraries/categories/${id}`);
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const getMiLibraryPurchases = async (params) => {
  try {
    const res = await axios.get(`/admin/mi-libraries/purchases`, { params });
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const getAppleIapProducts = async (params) => {
  try {
    const res = await axios.get(`/admin/apple-iap-products`, { params });
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};
